/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import CustomDateRangePicker from "./datePicker.jsx";
import {setCalenderData} from "../../../core/redux/filters/filter.action.jsx";
import {useDispatch,useSelector} from "react-redux";

import moment from "moment";
import {
  startOfYesterday,
  startOfWeek,
  addWeeks,
  addDays,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfYear,
  addYears,
  endOfYear,
  differenceInDays,
} from "date-fns";

const Calendar = () => {
  const translation = useSelector((state) => state.root.translation);
  const dispatch = useDispatch()
  const refSelected = useRef(null);
  const refCompare = useRef(null);
  // states
  const [selectedCalender, setSelectedCalender] = useState({});
  const urlExport = window.location.href.includes("export-data");
  const selected_period = useSelector((state) => state.root.selected_period) || "LAST_WEEK";
  const compare_period = useSelector((state) => state.root.compare_period) || "PREVIOUS_PERIOD";
  
  // Define your date ranges
  const st = startOfWeek(new Date(), { weekStartsOn: 0 });
  const d = addWeeks(new Date(), -1);
  const lw = startOfWeek(d, { weekStartsOn: 0 });
  const et = addDays(lw, 6);

  const periodSelected = [
    {
      value: "TODAY",
      label: translation?.today || "Today",
      range: { startDate: new Date(), endDate: new Date() },
    },
    {
      value: "YESTERDAY",
      label: translation?.yesterday || "Yesterday",
      range: { startDate: startOfYesterday(), endDate: startOfYesterday() },
    },
    {
      value: "THIS_WEEK",
      label: translation?.this_week || "This Week",
      range: { startDate: st, endDate: new Date() },
    },
    {
      value: "LAST_WEEK",
      label: translation?.last_week || "Last Week",
      range: { startDate: lw, endDate: et },
    },
    {
      value: "THIS_MONTH",
      label: translation?.this_month || "This Month",
      range: { startDate: startOfMonth(new Date()), endDate: new Date() },
    },
    {
      value: "LAST_MONTH",
      label: translation?.last_month || "Last Month",
      range: {
        startDate: startOfMonth(addMonths(new Date(), -1)),
        endDate: endOfMonth(addMonths(new Date(), -1)),
      },
    },
    {
      value: "THIS_YEAR",
      label: translation?.this_year || "This Year",
      range: { startDate: startOfYear(new Date()), endDate: new Date() },
    },
    {
      value: "LAST_YEAR",
      label: translation?.last_year || "Last Year",
      range: {
        startDate: addYears(startOfYear(new Date()), -1),
        endDate: addYears(endOfYear(new Date()), -1),
      },
    },
  ];
  // compare
  const periodCompared = [
    {
      label: translation?.previous_period || "Previous Period",
      value: "PREVIOUS_PERIOD",
    },
    {
      label: translation?.previous_year_same_period || "Previous Year Same Period",
      value: "PREVIOUS_YEAR_SAME_PERIOD",
    },
    {
      label: translation?.previous_year_same_day_of_week || "Previous Year Same Day of Week",
      value: "PREVIOUS_YEAR_SAME_DAY_OF_WEEK",
    },
  ];

  useEffect(() => {
    if (refSelected.current) {
      const selectedOption = periodSelected.find((v) => v.value == selected_period);
      refSelected.current.handleRangeChange(selectedOption, 'selected');
    }
    setTimeout(() => {
      if (refSelected.current) {
        const selectedOption = periodCompared.find(
          (v) => v.value == compare_period
        );
        refSelected.current.handleRangeChange(selectedOption, 'compare');
      }
      // for initail values submit
      submit()
    }, 100);
  }, [selected_period]);
  //
  const openDropDown = (name) => {
    const selectedRef = refSelected.current;
    const compareRef = refCompare.current;
    const toggleDropDown = (ref, closeOther = null) => {
      if (ref) {
        const { open, setOpen } = ref;
        setOpen(!open);
        // if (closeOther) {
        //   const { setOpen: close } = closeOther;
        //   close(false);
        // }
      }
    };
    if (name === 'selected') {
      toggleDropDown(selectedRef, compareRef);
    }
    if (name === 'compare') {
      toggleDropDown(compareRef, selectedRef);
    }
  }
  const dateOptionsComparedModelChangedNew = (option) => {

    let comparedOption = refSelected.current?.selectedRangeC?.value;
    if (!option) {
      comparedOption = refSelected.current?.selectedRangeC?.value;
    } else {
      comparedOption = option;
    }

    if (!Object.keys(selectedCalender).length) return;
    let { startDate, endDate } = selectedCalender;
    if (comparedOption === "PREVIOUS_PERIOD") {
      const diffDays = differenceInDays(startDate, endDate);
      const diffDaysPositive =
        diffDays < 0 ? (diffDays - 1) * -1 : diffDays + 1;
      const weeks = Math.ceil((diffDaysPositive / 7).toFixed(2));
      const rang = {
        range: {
          startDate: addWeeks(startDate, -weeks),
          endDate: addWeeks(endDate, -weeks),
        },
      };
      if (refSelected.current) {
        refSelected.current.handleCompairAssign(rang);
      }
    } else if (comparedOption === "PREVIOUS_YEAR_SAME_PERIOD") {
      const rang = {
        range: {
          startDate: addDays(new Date(startDate), -365),
          endDate: addDays(new Date(endDate), -365),
        },
      };
      if (refSelected.current) {
        refSelected.current.handleCompairAssign(rang);
      }
    } else if (comparedOption === "PREVIOUS_YEAR_SAME_DAY_OF_WEEK") {
      const rang = {
        range: {
          startDate: addDays(new Date(startDate), -364),
          endDate: addDays(new Date(endDate), -364),
        },
      };
      if (refSelected.current) {
        refSelected.current.handleCompairAssign(rang);
      }
    }
  };

  const handleSelectedDates = (dates, type) => {
    const selectedDates = dates[0];
    const { startDate, endDate } = selectedDates;
    const formatedDateS = moment(startDate).format("YYYY-MM-DD");
    const formatedDateE = moment(endDate).format("YYYY-MM-DD");
    if (type == "selected") {
      setSelectedCalender({ startDate: formatedDateS, endDate: formatedDateE });
    }
  };
  
  const cancel = () => {
    if (refSelected.current) {
      const selectedOption = periodSelected.find((v) => v.value == selected_period);
      refSelected.current.handleRangeChange(selectedOption, 'selected');
    }
    setTimeout(() => {
      if (refSelected.current) {
        const selectedOptionC = periodCompared.find(
          (v) => v.value == compare_period
        );
        refSelected.current.handleRangeChange(selectedOptionC, 'compare');
      }
      // for initail values submit
      // submit()
    }, 100);
    // setTimeout(() => {
    //   const selected = refSelected?.current?.state[0];
    //   const compare = refCompare.current.state[0];
    //   const payload = {
    //       selectedStart: moment(selected.startDate).format("YYYY-MM-DD"),
    //       selectedEnd: moment(selected.endDate).format("YYYY-MM-DD"),
    //       compareStart: moment(compare.startDate).format("YYYY-MM-DD"),
    //       compareEnd: moment(compare.endDate).format("YYYY-MM-DD"),
    //   };
    //   console.log('payload',payload)
    //   setCalenderData(payload)
    // }, 200);
  };
  const submit = () => {
    dateOptionsComparedModelChangedNew()
    setTimeout(() => {
      const selected = refSelected?.current?.state[0];
      const compare = refSelected?.current?.cState[0];
      if(selected && compare)
      {
      const payload = {
          selectedStart: moment(selected?.startDate).format("YYYY-MM-DD"),
          selectedEnd: moment(selected?.endDate).format("YYYY-MM-DD"),
          compareStart: moment(compare?.startDate).format("YYYY-MM-DD"),
          compareEnd: moment(compare?.endDate).format("YYYY-MM-DD"),
      };
      dispatch(setCalenderData(payload))
    }
    }, 200);
  };
  return (
    <div className="calender-wrapper">
     
      <CustomDateRangePicker
        ref={refSelected}
        calenderFor="selected"
        predefinedRanges={periodSelected}
        predefinedRangesC={periodCompared}
        selectedDates={handleSelectedDates}
        apply={submit}
        cancel= {cancel}
        openDropDown={openDropDown}
        callCompare={dateOptionsComparedModelChangedNew}
      />
      {/* compare */}
      {/* <span style={{ display: urlExport ? 'none' : 'inline' }}>
        <CustomDateRangePicker
          ref={refCompare}
          calenderFor="compare"
          predefinedRanges={periodCompared}
          selectedDates={handleSelectedDates}
          callCompare={dateOptionsComparedModelChangedNew}
          apply={submit}
          cancel= {cancel}
          openDropDown={openDropDown}
        />
      </span> */}
    </div>
  );
};

export default Calendar;